import { render, staticRenderFns } from "./TableDevices.vue?vue&type=template&id=fffc4038"
import script from "./TableDevices.vue?vue&type=script&lang=js"
export * from "./TableDevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports